import axios from "axios";
axios.defaults.withCredentials = true;
let baseUrl = process.env.REACT_APP_WS_SERVER_BASE_URL;

async function userLogin(payload) {
  try {
    let { data } = await axios.post(`${baseUrl}/api/user/login`, payload);
    return data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
}

async function userDetails() {
  try {
    let { data } = await axios.get(`${baseUrl}/api/user/me`);
    return data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
}

async function logoutApi() {
  try {
    let { data } = await axios.post(`${baseUrl}/api/user/logout`);
    return data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
}

async function contactUs(payload) {
  try {
    let { data } = await axios.post(`${baseUrl}/api/contactus`, payload);
    return data;
  } catch (error) {
    console.log(
      "Error in contactUs API:",
      error.response?.data || error.message
    );
    return (
      error.response?.data || {
        status: false,
        msg: "An unexpected error occurred.",
      }
    );
  }
}
export { userLogin, contactUs, userDetails, logoutApi };
